import { AGSFeatureTypes } from "ags/integration/schema/ags-spin-response-schema";
import { SpinRecordBuilder } from "ags/integration/builders/records/spin-record-builder";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import { AGSSpinSchema } from "ags/integration/schema/ags-spin-response-schema";
import { HoldAndSpinRecord } from "ags/integration/records/hold-and-spin-record";
import Record from "slotworks/model/gameplay/records/record";

export class MCSpinRecordBuilder extends SpinRecordBuilder implements RecordBuilder {

    public id: string = "MCSpinRecordBuilder";

    public buildRecord(spin: AGSSpinSchema, freespin: boolean, rootSpin: AGSSpinSchema) {

        this.fixDualGateIssue(spin);

        const record = super.buildRecord(spin, freespin, rootSpin);

        return record;
    }

    /**
     * On a combo bonus the server incorrectly marks both bonuses with gate = true. As a work around if we detect
     * multiple gateways we find the one which also has a valid wildIndex (wilds don't triggers the gateway) and remove
     * it's gateway by updating it with `gate = false`.
     *
     * @param spin
     */
    protected fixDualGateIssue(spin: AGSSpinSchema) {
        let gates = 0;
        spin.wins.forEach((win: any) => {
            if (win.gate) {
                gates++;
            }
        });

        if (gates > 1) {
            spin.wins.forEach((win: any) => {
                if (win.wildIndex > 0) {
                    win.gate = false;
                }
            });
        }
    }
}

export default new MCSpinRecordBuilder();
